import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule, TextTooltipModule } from '@lib/components';
import { MyBookingTabsItemComponent } from './my-booking-tabs-item.component';
import { MyBookingTabsComponent } from './my-booking-tabs.component';
import { StaticMsgModule } from '@lib/pipes/static-msg/static-msg.module';

@NgModule({
  imports: [CommonModule, ButtonModule, TextTooltipModule, StaticMsgModule],
  declarations: [MyBookingTabsComponent, MyBookingTabsItemComponent],
  exports: [MyBookingTabsComponent, MyBookingTabsItemComponent],
})
export class MyBookingTabsModule {}
